// extracted by mini-css-extract-plugin
module.exports = {"style-buttons":"style_style-buttons__2jpkP"};